import React, { useEffect, useState } from 'react';

const PlantillaTest = () => {
  return (
    <>
    <section className="hero-section hero-4 bg-cover fix" style={{ backgroundImage: `url(/assets/kidsa/assets/img/hero/bottom.png)` }}>
      <div className="hero-content">
        <div className="row g-4 align-items-center">
            Admision
          <div className="" data-wow-delay=".8s">
            <a></a>
          </div>
          <div className="col-lg-6">
         Proceso de admisión
          </div>
        </div>
      </div>
    </section>
    </>
  );
};

export default PlantillaTest;